module.exports = __webpack_public_path__ + "group.d96ed41b24ea11522b00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/group.png
// module id = ./src/assets/img/group.png
// module chunks = main